<template>
  <b-nav tabs>
    <b-nav-item v-for="tab in tabs" :key="tab.name" :to="{ name: tab.name }" :active="isActive(tab.name)" router>
      {{ tab.label }}
    </b-nav-item>
  </b-nav>

  <router-view />
</template>

<script lang="ts">
import { BNav, BNavItem } from 'bootstrap-vue-next'
import { defineComponent } from 'vue'
import { useRoute } from 'vue-router'
import { CARRIER_MESSAGES, FORWARDING_HUB, PROXY_MESSAGES } from '@/types/router'

export default defineComponent({
  name: 'MessagesBase',
  components: { BNav, BNavItem },
  setup() {
    const route = useRoute()

    const tabs = [
      { name: PROXY_MESSAGES, label: 'Proxy messages' },
      { name: CARRIER_MESSAGES, label: 'Carrier messages' },
      { name: FORWARDING_HUB, label: 'Service-point forwarding hub' },
    ]

    const isActive = (name: string) => route.name === name

    return {
      tabs,
      isActive,
    }
  },
})
</script>
